import { PlaybackStateFilter, Sort, useAuthStateStore } from '@annunciate/core';
import { COLLECTION_ITEMS_GET } from '@annunciate/query/dist/queries/collectionItem';
import { useInfiniteQuery } from './base';
export const useCollectionItemQuery = ({ parentId, displayMode, terminatingTypes, filter, shouldObserveUser = false, }) => {
    const { uuid, hasAuthInitialized } = useAuthStateStore((state) => ({
        uuid: state.uuid,
        hasAuthInitialized: state.hasAuthInitialized,
    }));
    const playbackFilter = filter?.playbackState === PlaybackStateFilter.UNPLAYED ? 'UNPLAYED' : 'ALL';
    const variables = {
        parentId,
        displayMode,
        terminatingTypes,
        sortField: filter?.sortField,
        sortOrder: filter?.sortOrder !== undefined
            ? filter.sortOrder === Sort.DESC ? 'DESC' : 'ASC'
            : undefined,
        playbackFilter,
        page: 0,
        perPage: 20,
    };
    const { fetchNextPage, fetchPreviousPage, hasNextPage, hasPreviousPage, isFetchingNextPage, isFetchingPreviousPage, isPending, data, } = useInfiniteQuery({
        key: [`collectionItems`, shouldObserveUser ? uuid : 'anyone'],
        query: COLLECTION_ITEMS_GET,
        variables,
    });
    const items = data?.pages?.reduce((all, page) => {
        all.push(...page.items);
        return all;
    }, []);
    return {
        fetchNextPage,
        fetchPreviousPage,
        hasNextPage,
        hasPreviousPage,
        isFetchingNextPage,
        isFetchingPreviousPage,
        isPending: !shouldObserveUser ? isPending : !hasAuthInitialized || isPending,
        data: items || [],
    };
};
//# sourceMappingURL=useCollectionItemQuery.js.map